import axios from "axios";

export const getAnalysisPlanSuggestions = (organizationId, lng = "fr") => {
  const requestUrl = `/team/analyses-plans`;

  return axios.get(requestUrl, {
    params: {
      organization: organizationId,
      lng: lng.charAt(0).toUpperCase() + lng.slice(1)
    }
  });
};

export const updateAnalysisPlanSettings = ({ organization, id, labels }) => {
  const requestUrl = `/team/analysis-plan/edit`;

  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("id", id);
  formData.append("labelFr", labels.fr);
  formData.append("labelEn", labels.en);
  formData.append("labelNl", labels.nl);
  formData.append("superCategory", labels.superCategory);

  return axios.post(requestUrl, formData);
};

export const deleteAnalysisPlanSettings = ({ organization, isForced, id }) => {
  const requestUrl = `/team/analysis-plan/remove`;

  let formData = new FormData();
  formData.append("id", id);
  formData.append("isForced", isForced);
  formData.append("organization", organization);

  return axios.post(requestUrl, formData);
};

export const saveAnalysisPlanSettings = ({ organization, labels }) => {
  const requestUrl = `/team/analysis-plan/add`;
  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("labelFr", labels.fr);
  formData.append("labelEn", labels.en);
  formData.append("labelNl", labels.nl);

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/analysis-plan.js